/* eslint-disable react-hooks/exhaustive-deps */

import React, {useContext, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Accordion, Checkbox} from '../../components';
import * as Actions from '../../store/actions';
import {EasyOnboardContext} from '../../helpers/context';
import {settings} from '../../assets/images/images';
import Confirmation from './SettingsModals/Confirmation';

const defaultUrl = 'https://example.co';
function ConfirmationPage({
  isChecked,
  onCheck,
  setUrl,
  widgets: {singleWidget},
  setScreenType,
}) {
  const [checked, setChecked] = useState(true);
  const [open, setOpen] = useState(false);
  const {widgetData, setWidgetData} = useContext(EasyOnboardContext);

  useEffect(() => {
    setChecked(!singleWidget?.widget?.redirect_url);
    setWidgetData({
      ...widgetData,
      redirect_url: singleWidget?.widget?.redirect_url,
      name: singleWidget?.widget?.name,
    });
  }, [setWidgetData, singleWidget?.widget, singleWidget?.widget?.redirect_url]);

  const handleChange = e => {
    setChecked(e.target.checked);
    setWidgetData({...widgetData, redirect_url: e.target.checked && null});
    onCheck && onCheck(e.target.checked);
  };
  const checkedValue = isChecked ? isChecked : checked;

  const redirectUrl = !checked
    ? widgetData?.redirect_url ||
      singleWidget?.widget?.redirect_url ||
      defaultUrl
    : defaultUrl;

  return (
    <Accordion
      title="Confirmation page"
      onClick={() => {
        setScreenType('confirmation_page');
      }}
    >
      <p className="text-xs text-body leading-[18px]">
        Confirm verification process
      </p>

      <Confirmation setOpen={setOpen} open={open} />

      <div className="mt-4">
        <div className="flex items-center justify-between">
          <Checkbox
            onChange={handleChange}
            noLeftPadding
            label="Use default confirmation page"
            isChecked={checked}
          />

          <button onClick={() => setOpen(!open)}>
            <img src={settings} alt="icon" width={18} height={18} />
          </button>
        </div>

        <label
          data-smallerlabel=""
          htmlFor="confidence_level"
          className="mt-4 mb-2"
        >
          Redirect to
          <input
            disabled={checkedValue}
            style={{cursor: checkedValue && 'not-allowed'}}
            onChange={setUrl}
            type="text"
            id="confidence_level"
            className={`mt-2 text-sm ${
              !redirectUrl?.includes('example.co') && 'placeholder:text-grey'
            }`}
            placeholder={redirectUrl}
          />
        </label>
      </div>
    </Accordion>
  );
}

export default connect(state => state, Actions)(ConfirmationPage);
